import React from "react";

import styles from "./SearchLoader.module.scss";

interface Props {
  text: string;
}

export const SearchLoader = ({ text }: Props) => (
  <div className={styles.searchLoader__wrapper}>
    <i className={`icon icon-search ${styles.searchLoader__searchIcon}`} />
    <p>{text}</p>
  </div>
);
